import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';

interface WaveProps {
  position?: 'top' | 'bottom';
  flip?: boolean;
  zIndex?: number;
}

const WaveSVG = styled.svg<WaveProps>`
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  right: 0;
  z-index: ${props => props.zIndex || 0};
  ${props => props.position === 'top' ? 'top: 0;' : 'bottom: 0;'}
  ${props => props.flip ? 'transform: scaleX(-1);' : ''}
`;

export const TopWaves: React.FC = () => (
  <>
    <WaveSVG 
      position="top" 
      viewBox="0 0 1440 320" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={1}
    >
      <path 
        fill={theme.colors.primary} 
        fillOpacity="0.4" 
        d="M0,224L48,202.7C96,181,192,139,288,144C384,149,480,203,576,208C672,213,768,171,864,144C960,117,1056,107,1152,122.7C1248,139,1344,181,1392,202.7L1440,224L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
      ></path>
    </WaveSVG>
    <WaveSVG 
      position="top" 
      viewBox="0 0 1440 320" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={2}
    >
      <path 
        fill={theme.colors.primaryLight} 
        fillOpacity="0.3" 
        d="M0,128L48,122.7C96,117,192,107,288,101.3C384,96,480,96,576,112C672,128,768,160,864,165.3C960,171,1056,149,1152,160C1248,171,1344,213,1392,234.7L1440,256L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
      ></path>
    </WaveSVG>
    <WaveSVG 
      position="top" 
      viewBox="0 0 1440 320" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={3}
    >
      <path 
        fill={theme.colors.accent} 
        fillOpacity="0.2" 
        d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,90.7C672,85,768,107,864,144C960,181,1056,235,1152,229.3C1248,224,1344,160,1392,128L1440,96L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
      ></path>
    </WaveSVG>
  </>
);

export const BottomWaves: React.FC = () => (
  <>
    <WaveSVG 
      position="bottom" 
      viewBox="0 0 1440 320" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={1}
    >
      <path 
        fill={theme.colors.accent} 
        fillOpacity="0.4" 
        d="M0,96L48,112C96,128,192,160,288,165.3C384,171,480,149,576,149.3C672,149,768,171,864,154.7C960,139,1056,85,1152,74.7C1248,64,1344,96,1392,112L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
      ></path>
    </WaveSVG>
    <WaveSVG 
      position="bottom" 
      viewBox="0 0 1440 320" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={2}
    >
      <path 
        fill={theme.colors.tertiary} 
        fillOpacity="0.3" 
        d="M0,192L48,208C96,224,192,256,288,261.3C384,267,480,245,576,224C672,203,768,181,864,186.7C960,192,1056,224,1152,229.3C1248,235,1344,213,1392,202.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
      ></path>
    </WaveSVG>
    <WaveSVG 
      position="bottom" 
      viewBox="0 0 1440 320" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={3}
    >
      <path 
        fill={theme.colors.secondary} 
        fillOpacity="0.2" 
        d="M0,256L48,261.3C96,267,192,277,288,277.3C384,277,480,267,576,240C672,213,768,171,864,165.3C960,160,1056,192,1152,202.7C1248,213,1344,203,1392,197.3L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
      ></path>
    </WaveSVG>
  </>
);

// Keep these for backwards compatibility and for the sign-up page
export const TopCornerWave: React.FC = () => (
  <WaveSVG 
    position="top" 
    viewBox="0 0 1440 320" 
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      fill={theme.colors.primaryLight} 
      fillOpacity="0.4" 
      d="M0,224L80,213.3C160,203,320,181,480,181.3C640,181,800,203,960,224C1120,245,1280,267,1360,277.3L1440,288L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
    ></path>
  </WaveSVG>
);

export const BottomCornerWave: React.FC = () => (
  <WaveSVG 
    position="bottom"
    flip
    viewBox="0 0 1440 320" 
    preserveAspectRatio="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      fill={theme.colors.tertiary} 
      fillOpacity="0.4" 
      d="M0,224L80,213.3C160,203,320,181,480,181.3C640,181,800,203,960,224C1120,245,1280,267,1360,277.3L1440,288L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
    ></path>
  </WaveSVG>
);

// For backward compatibility
export const TopWave = TopWaves;
export const BottomWave = BottomWaves;

// Smaller waves specifically for header accents
export const HeaderWaves: React.FC = () => (
  <>
    {/* Primary wave - deepest and most prominent */}
    <WaveSVG 
      position="bottom" 
      viewBox="0 0 1440 60" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={1}
    >
      <path 
        fill={theme.colors.primary} 
        fillOpacity="0.3" 
        d="M0,60L60,56.3C120,52.5,240,45,360,43.5C480,42,600,46.5,720,48.8C840,51,960,51,1080,46.5C1200,42,1320,33,1380,28.5L1440,24L1440,60L1380,60C1320,60,1200,60,1080,60C960,60,840,60,720,60C600,60,480,60,360,60C240,60,120,60,60,60L0,60Z"
      ></path>
    </WaveSVG>

    {/* Secondary wave - vibrant accent layer */}
    <WaveSVG 
      position="bottom" 
      viewBox="0 0 1440 48" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={2}
    >
      <path 
        fill={theme.colors.secondary} 
        fillOpacity="0.25" 
        d="M0,48L80,45.8C160,43.5,320,39,480,36.8C640,34.5,800,34.5,960,38.3C1120,42,1280,49.5,1360,53.3L1440,57L1440,48L1360,48C1280,48,1120,48,960,48C800,48,640,48,480,48C320,48,160,48,80,48L0,48Z"
      ></path>
    </WaveSVG>

    {/* Tertiary wave - warm middle tone */}
    <WaveSVG 
      position="bottom" 
      viewBox="0 0 1440 36" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={3}
    >
      <path 
        fill={theme.colors.tertiary} 
        fillOpacity="0.28" 
        d="M0,36L48,33.8C96,31.5,192,27,288,28.5C384,30,480,37.5,576,39.8C672,42,768,39,864,34.5C960,30,1056,24,1152,22.5C1248,21,1344,24,1392,25.5L1440,27L1440,36L1392,36C1344,36,1248,36,1152,36C1056,36,960,36,864,36C768,36,672,36,576,36C480,36,384,36,288,36C192,36,96,36,48,36L0,36Z"
      ></path>
    </WaveSVG>

    {/* Accent wave - complementary layer */}
    <WaveSVG 
      position="bottom" 
      viewBox="0 0 1440 24" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={4}
    >
      <path 
        fill={theme.colors.accent} 
        fillOpacity="0.22" 
        d="M0,24L72,22.5C144,21,288,18,432,18.8C576,19.5,720,25.5,864,27.8C1008,30,1152,28.5,1224,27.8L1296,27L1440,25.5L1440,24L1296,24C1224,24,1008,24,864,24C720,24,576,24,432,24C288,24,144,24,72,24L0,24Z"
      ></path>
    </WaveSVG>

    {/* Primary light wave - subtle top layer */}
    <WaveSVG 
      position="bottom" 
      viewBox="0 0 1440 15" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      zIndex={5}
    >
      <path 
        fill={theme.colors.primaryLight} 
        fillOpacity="0.18" 
        d="M0,15L120,13.5C240,12,480,9,720,10.5C960,12,1200,18,1320,21L1440,24L1440,15L1320,15C1200,15,960,15,720,15C480,15,240,15,120,15L0,15Z"
      ></path>
    </WaveSVG>
  </>
); 